// plugins/hammer.js
import Hammer from 'hammerjs';

export default {
    install(Vue) {
        Vue.directive('swipe-back', {
            bind(el, binding, vnode) {
                const mc = new Hammer(el);
                mc.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });

                mc.on('swiperight swipeleft', () => {
                    console.log("tap detected")
                    if (window.history.length > 1) {
                        vnode.context.$router.go(-1);
                    }
                });

                // Store the manager instance for cleanup
                el._hammer = mc;
            },
            unbind(el) {
                if (el._hammer) {
                    el._hammer.destroy();
                }
            }
        });
    }
};